import { createContext, useContext } from 'react';
import { toolOutputHrefs } from '../../lib/applinks/appLinks';
import { isMessagePartTool } from './types';
const ChatLinksContext = /*#__PURE__*/ createContext(null);
export const ChatLinksProvider = ChatLinksContext.Provider;
export const useChatLinks = ()=>useContext(ChatLinksContext);
/**
 * Collect the tool hrefs of a thread. A read-only thread (someone else's
 * chat) links nothing: its tools ran as its owner, whose access is not the
 * viewer's.
 */ export function collectChatLinks(messages, readOnly) {
    const hrefs = new Set();
    if (!readOnly) {
        for (const message of messages){
            for (const part of message.parts){
                if (!isMessagePartTool(part)) continue;
                for (const href of toolOutputHrefs(part.output))hrefs.add(href);
            }
        }
    }
    return {
        hrefs
    };
}
